import React, { useCallback, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { InputSwitch } from "primereact/inputswitch";
import SitesService from "../../../../services/AuraCamera/sites/sites.service";
import { useParams } from "react-router-dom";
import { use } from "i18next";
import { Toast } from "primereact/toast";
import LocationMapPopup from "./location-map-popup";
import { useSelector } from "react-redux";
import { AutoComplete } from "primereact/autocomplete";
import TokenService from "../../../../services/autentication/token.service";
//import mapData from "../map/sites_map_details.json";

interface editdata {
  customerName: String;
  companyName: String;
  siteName: String;
  city: String;
  state: String;
  contactName: String;
  phone: any;
  zip: any;
  notes: String;
  latitude?: Number;
  status: String;
  location: Number;
}

const AddEditForm = (props: any) => {
  const session = window.localStorage;
  const userProfile = useSelector(
    (state: any) => state.AuraCameraCommon.userInfo
  );
  const msgToast = useRef<any>(null);
  const { id } = useParams();
  const isAddMode = !id;
  const { CustomerList, AllSitesData } = props;

  const [idData, setIdData] = useState<any>(null);
  const [mapData, setMapData] = useState<any>({
    lati: 29.618672,
    lon: -95.641942,
  });
  const [mapPopupInput, setMapPopupInput] = useState<any>("29.618672,-95.641942");
  const [locationValue, setLocationValue] = useState<any>("");
  const [checked, setChecked] = useState(true);
  const [filterChacked, setfilterChacked] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [enableLDR, setEnableLRD] = useState(false);
  const [selectedTempCompany, setSelectedTempCompany] = useState<any>(null);
  const [siteCustomers, setSiteCustomers] = useState([]);
  const [permanentSiteCustomers, setPermanentSiteCustomers] = useState([]);
  const [filteredSiteCustomer, setFilteredSiteCustomer] = useState<any>(null);
  const [companyNameDisabled, setCompanyNameDisabled] = useState(true);
  const [customerNameDisabled, setCustomerNameDisabled] = useState(false);
  const [companyID, setCompanyID] = useState(null);
  var navigate = useNavigate();

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      customerId: "",
      companyName: "",
      siteName: "",
      city: "",
      state: "",
      contactName: "",
      phone: "",
      zip: "",
      notes: "",
      maplatlong: "",
      status: "",
    },
  });

  const fetchData = useCallback(async () => {
    const data = await SitesService.sitesGetAllCustomers().then((res) => {
      setPermanentSiteCustomers(res);
      setSiteCustomers(res);
    });
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  const getUser = TokenService.getUser();
  
  if (getUser?.superAdmin == true || getUser?.globalAdmin == true){
    navigate('/aura-camera/sites')
  }else{
    if(enableLDR == true){
      navigate('/aura-camera/sites')
    }
  }
  useEffect(() => {
    if (id) {
      const singleSite =
        AllSitesData && AllSitesData?.filter((item: any) => item._id === id);
      if (singleSite && singleSite.length > 0) {
        setIdData(singleSite[0]);
        setCompanyID(singleSite[0].companyId);
      }
    } else {
      setIdData(null);
    }
  }, [id, AllSitesData]);

  useEffect(() => {
    if (idData && idData.status === "false") {
      setfilterChacked(false);
    } else {
      setfilterChacked(true);
    }
    if (idData && idData.status === "false") {
      setChecked(false);
    } else {
      setfilterChacked(true);
    }
    if (idData && idData.latitude && idData.longitude) {
      setLocationValue(
        `${idData?.latitude.slice(0, 9)},${idData?.longitude.slice(0, 9)}`
      );
      setMapPopupInput(`${idData?.latitude},${idData?.longitude}`);
      setMapData({
        lati: Number(idData?.latitude),
        lon: Number(idData?.longitude),
      });
      reset({
        customerId: idData?.customerId,
        companyName: idData?.companyName,
        siteName: idData?.siteName,
        city: idData?.city,
        state: idData?.state,
        contactName: idData?.contactName,
        phone: idData?.phone,
        zip: idData?.zip,
        notes: idData?.notes,
        maplatlong: `${idData?.latitude},${idData?.longitude}`,
        status: idData?.status,
      });
    }
  }, [idData, checked, CustomerList]);

  useEffect(() => {
    if (permanentSiteCustomers?.length > 0 && idData?.customerId) {
      const curRecord: any = permanentSiteCustomers?.filter(
        (itm: any) => itm?.customerID == idData?.customerId
      );
      if (curRecord[0]?.isLDR == true) {
        setEnableLRD(true);
        setSelectedTempCompany(idData?.companyName);
        setCompanyID(idData?.customerId);
      } else {
        if (id) {
          setIdData({
            ...idData,
            companyName: idData?.companyName,
            cameraCustId: idData?.cameraCustId,
          });
          reset({
            companyName: idData?.companyName,
          });
        } else {
          setIdData({
            ...idData,
            companyName: curRecord[0]?.name,
          });
          reset({
            companyName: curRecord[0]?.name,
          });
        }

        setEnableLRD(false);
      }
    }
    const getUser = TokenService.getUser();
    if (getUser && getUser?.customerID) {
      const res: any = permanentSiteCustomers?.filter(
        (itm: any) => itm.customerID == getUser?.customerID
      );
      if (res && res[0]?.customerID) {
        const orgCustomer = CustomerList?.filter(
          (itm: any) => itm.name == getUser?.customerID
        );
        if (res[0]?.isLDR == true) {
          setEnableLRD(true);
          if (idData?.companyName) {
            setSelectedTempCompany(idData?.companyName);
          } else {
            setSelectedTempCompany(res[0]?.name);
          }
        } else {
          setCompanyID(res[0]?.customerID);
          setEnableLRD(false);
        }
        if (id) {
          setIdData({
            ...idData,
            companyName: idData?.companyName,
            customerId:
              orgCustomer?.length > 0
                ? orgCustomer[0]?.customerID
                : res[0]?.customerID,
          });
          reset({
            companyName: idData?.companyName,
            customerId:
              orgCustomer?.length > 0
                ? orgCustomer[0]?.customerID
                : res[0]?.customerID,
          });
        } else {
          setTimeout(()=>{
            setIdData({
              ...idData,
              cameraCustId: res[0]?.cameraCustId,
              companyName: res[0]?.name,
              customerId:
                orgCustomer?.length > 0
                  ? orgCustomer[0]?.customerID
                  : res[0]?.customerID,
            });
            reset({
              companyName: res[0]?.name,
              customerId:
                orgCustomer?.length > 0
                  ? orgCustomer[0]?.customerID
                  : res[0]?.customerID,
            });
          },1000);
        }
        setCustomerNameDisabled(true);
      }
    }
  }, [permanentSiteCustomers]);

  //updated data
  const editNewData = (e: any) => {
    //let custSelectedID;
    let temp_check_filter = filterChacked ? "true" : "false";
    if (e.target.name === "status") {
      temp_check_filter = e.target.value ? "true" : "false";
      if (temp_check_filter === "true") {
        setfilterChacked(true);
      } else {
        setfilterChacked(false);
      }
    } else {
    }

    setIdData({
      ...idData,
      [e.target.name]: e.target.value,
      status: temp_check_filter,
      modified_by: userProfile.userID,
      modified_date: new Date().toISOString(),
    });
  };

  //to set map location on popup
  const handleMapLatLon = () => {
    let checkEnteredValue = mapPopupInput;
    let flag_errors = false;
    if (
      checkEnteredValue === "" ||
      checkEnteredValue === null ||
      checkEnteredValue === undefined
    ) {
      flag_errors = true;
    } else {
      let temp_check_array = checkEnteredValue.split(",");
      if (temp_check_array.length <= 1 || temp_check_array.length > 2) {
        flag_errors = true;
      } else {
        let number1 = Number(temp_check_array[0]);
        let number2 = Number(temp_check_array[1]);

        if (
          isNaN(number1) ||
          isNaN(number2) ||
          number2 === 0 ||
          number1 === 0
        ) {
          flag_errors = true;
        } else {
          flag_errors = false;
          setModalVisible(false);
          setIdData({
            ...idData,
            latitude: String(mapData.lati).slice(0, 9),
            longitude: String(mapData.lon).slice(0, 9),
          });
        }
      }
    }
  };
  const handleCustomerNameChange = async (e: any) => {
    setIdData({
      ...idData,
      customerId: e.target.value,
    });
    reset({
      customerId: e.target.value,
    });
    if (e?.target?.value?.length > 0) {
      if (permanentSiteCustomers?.length > 0) {
        const curRecord: any = permanentSiteCustomers?.filter(
          (itm: any) => itm?.customerID == e?.target?.value
        );
        if (curRecord[0]?.isLDR == true) {
          setEnableLRD(true);
        } else {
          setIdData({
            ...idData,
            companyName: curRecord[0]?.name,
            customerId: e.target.value,
          });
          reset({
            companyName: curRecord[0]?.name,
            customerId: e.target.value,
          });
          setEnableLRD(false);
        }
      } else {
        const customerRecords = await SitesService.sitesGetAllCustomers().then(
          (res) => {
            if (res?.length > 0) {
              setPermanentSiteCustomers(res);
              setSiteCustomers(res);
              const curRecordN: any = res?.filter(
                (itm: any) => itm?.customerID == e?.target?.value
              );
              if (curRecordN[0]?.isLDR == true) {
                setEnableLRD(true);
              } else {
                setIdData({
                  ...idData,
                  companyName: curRecordN[0]?.name,
                  customerId: e.target.value,
                });
                reset({
                  companyName: curRecordN[0]?.name,
                  customerId: e.target.value,
                });
                setEnableLRD(false);
              }
            }
          }
        );
      }
    } else {
      setEnableLRD(false);
    }
  };

  // for map popup input
  const handleInput = (e: any) => {
    setMapPopupInput(e.target.value);
  };

  // for success toast.
  const showToast = (
    severityValue: any,
    summaryValue: any,
    detailValue: any
  ) => {
    msgToast?.current?.clear();
    msgToast?.current?.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const onSubmit = async (data: any) => {
    const arrLatLong = data.maplatlong.split(",");
    var payload = {
      ...data,
      CompanyId: companyID,
      CameraCustId: idData?.cameraCustId,
      latitude: arrLatLong[0],
      longitude: arrLatLong[1],
      created_By: userProfile?.userID,
      created_date: new Date().toISOString(),
      modified_by: userProfile?.userID,
      modified_date: new Date().toISOString(),
      totalObservationPoints: 0,
      totalPoints: 0,
    };
    if (id) {
      payload = {
        ...data,
        latitude: arrLatLong[0],
        longitude: arrLatLong[1],
        created_By: userProfile?.userID,
        created_date: new Date().toISOString(),
        modified_by: userProfile?.userID,
        modified_date: new Date().toISOString(),
        totalObservationPoints: 0,
        totalPoints: 0,
      };
    }

    if (companyID == null) {
      showToast(
        "error",
        "Error Message",
        "Please select Company From the Dropdown"
      );
    } else {
      if (id) {
        // Update Site
        const updatedResponse = await SitesService.SitesOnboradUpdateApiData(
          idData,
          id
        );
        if (updatedResponse === "Site updated successfully.") {
          session.setItem("setSiteUpdateToastFlag", "true");
          navigate(`/aura-camera/sites`);
        } else {
          showToast("warn", "Duplicate record", "Site name already exist!");
        }
      } else {
        const postResponse = await SitesService.SitesOnboradPostApiData(
          payload
        );

        if (postResponse == "error") {
          showToast("warn", "Duplicate record", "Site name already exist!");
        } else {
          session.setItem("setSiteCreateToastFlag", "true");
          navigate(`/aura-camera/sites`);
        }
      }
    }
  };

  const search = (event: any) => {
    if (event?.query?.length >= 3) {
      // Timeout to emulate a network connection
      setTimeout(() => {
        let _filteredSiteCustomer: any;

        if (!event.query.trim().length) {
          _filteredSiteCustomer = [...siteCustomers];
        } else {
          _filteredSiteCustomer = siteCustomers.filter((country: any) => {
            return country.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
        setFilteredSiteCustomer(_filteredSiteCustomer);
      }, 250);
    }
  };

  return (
    <>
      <Toast ref={msgToast} />
      <form
        className="row"
        onSubmit={handleSubmit(onSubmit)}
        autoComplete="new-password"
        spellCheck={false}
      >
        <div className="col-md-6" style={{ display: "none" }}>
          <label className="form-label">
            Service Provider Name<sup className="required">*</sup>
          </label>
          <select
            value={idData?.customerId}
            {...register("customerId", { required: true })}
            name="customerId"
            className="form-control"
            autoComplete="off"
            // onChange={editNewData}
            onChange={(e: any) => handleCustomerNameChange(e)}
            disabled={customerNameDisabled}
          >
            {CustomerList &&
              CustomerList.map((custlist: any) => {
                return (
                  <option
                    key={custlist?.customerID}
                    value={custlist?.customerID}
                  >
                    {custlist?.name}
                  </option>
                );
              })}
          </select>
          {errors?.customerId && (
            <span className="error">Service Provider is required</span>
          )}
        </div>
        <div
          className="col-md-6 autoComplete-dropdown"
          style={{ display: `${enableLDR == true ? "block" : "none"}` }}
        >
          <label className="form-label">
            Company Name<sup className="required">*</sup>
          </label>
          {enableLDR == true ? (
            <AutoComplete
              field="name"
              value={selectedTempCompany}
              {...register("companyName", { required: true })}
              //dropdown
              suggestions={filteredSiteCustomer}
              completeMethod={search}
              onChange={(e) => {
                if (e?.value?.customerID) {
                  setCompanyID(e?.value?.customerID);
                } else {
                  setCompanyID(null);
                }
                setSelectedTempCompany(e.value);
                setIdData({
                  ...idData,
                  companyName: e?.value?.name ? e?.value?.name : e?.value,
                });
              }}
              className="form-control"
            />
          ) : (
            <input
              type="text"
              value={idData?.companyName}
              {...register("companyName", {
                required: true,
                pattern: /^[a-zA-Z0-9 ]+$/i,
              })}
              name="companyName"
              placeholder="Company Name"
              className="form-control"
              autoComplete="new-password"
              spellCheck={false}
              onChange={editNewData}
              disabled={companyNameDisabled}
            />
          )}
          {errors?.companyName?.type === "required" && (
            <span className="error">Company Name is required</span>
          )}
          {errors?.companyName?.type === "pattern" && (
            <span className="error">Alphabetical characters only</span>
          )}
        </div>
        <div className="col-md-6">
          <label className="form-label">
            Site Name<sup className="required">*</sup>
          </label>
          <input
            type="text"
            value={idData?.siteName}
            {...register("siteName", {
              required: true,
              pattern: /^[a-zA-Z0-9 -]+$/i,
            })}
            name="siteName"
            placeholder="Site Name"
            className="form-control"
            autoComplete="new-password"
            spellCheck={false}
            onChange={editNewData}
          />
          {errors?.siteName?.type === "required" && (
            <span className="error">Site name is required</span>
          )}
          {errors?.siteName?.type === "pattern" && (
            <span className="error">Alphanumeric characters only</span>
          )}
        </div>
        <div className="col-md-6">
          <label className="form-label">
            City<sup className="required">*</sup>
          </label>
          <input
            type="text"
            value={idData?.city}
            {...register("city", {
              required: true,
              pattern: /^[a-zA-Z ]+$/i,
            })}
            name="city"
            placeholder="City"
            className="form-control"
            autoComplete="new-password"
            spellCheck={false}
            onChange={editNewData}
          />
          {errors?.city?.type === "required" && (
            <span className="error">City is required</span>
          )}
          {errors?.city?.type === "pattern" && (
            <span className="error">Alphabetical characters only</span>
          )}
        </div>
        <div className="col-md-6">
          <label className="form-label">
            State<sup className="required">*</sup>
          </label>
          <input
            type="text"
            value={idData?.state}
            {...register("state", { required: true, pattern: /^[a-zA-Z ]+$/i })}
            name="state"
            placeholder="State"
            className="form-control"
            autoComplete="new-password"
            spellCheck={false}
            onChange={editNewData}
          />
          {errors?.state?.type === "required" && (
            <span className="error">State is required</span>
          )}
          {errors?.state?.type === "pattern" && (
            <span className="error">Alphabetical characters only</span>
          )}
        </div>
        <div className="col-md-6">
          <label className="form-label">
            Site Contact Name<sup className="required">*</sup>
          </label>
          <input
            type="text"
            value={idData?.contactName}
            {...register("contactName", {
              required: true,
              pattern: /^[a-zA-Z0-9 ]+$/i,
            })}
            name="contactName"
            placeholder="Contact Name"
            className="form-control"
            autoComplete="new-password"
            spellCheck={false}
            onChange={editNewData}
          />
          {errors?.contactName?.type === "required" && (
            <span className="error">Contact Name is required &nbsp;</span>
          )}
          {errors?.contactName?.type === "pattern" && (
            <span className="error">Alphabetical characters only</span>
          )}
        </div>
        <div className="col-md-6">
          <label className="form-label">
            Phone<sup className="required">*</sup>
          </label>
          <input
            type="number"
            value={idData?.phone}
            {...register("phone", {
              required: true,
              maxLength: 10,
              pattern: /^[0-9]+$/i,
            })}
            name="phone"
            placeholder="Phone Number"
            className="form-control"
            autoComplete="new-password"
            spellCheck={false}
            onChange={editNewData}
          />
          {errors?.phone?.type === "required" && (
            <span className="error">Phone is required &nbsp;</span>
          )}
          {errors?.phone?.type === "pattern" && (
            <span className="error">Enter numbers only</span>
          )}
          {errors?.phone?.type === "maxLength" && (
            <span className="error">Phone Number cannot exceed 10 digits</span>
          )}
        </div>
        <div className="col-md-6">
          <label className="form-label">
            Zip<sup className="required">*</sup>
          </label>
          <input
            type="number"
            value={idData?.zip}
            {...register("zip", {
              required: true,
              maxLength: 10,
              pattern: /^[0-9]+$/i,
            })}
            name="zip"
            placeholder="Zip"
            className="form-control"
            autoComplete="new-password"
            spellCheck={false}
            onChange={editNewData}
          />
          {errors?.zip?.type === "required" && (
            <span className="error">Zip is required</span>
          )}
          {errors?.zip?.type === "pattern" && (
            <span className="error">Enter numbers only</span>
          )}
          {errors?.zip?.type === "maxLength" && (
            <span className="error">Zip cannot exceed 10 digits</span>
          )}
        </div>
        <div className="col-md-6">
          <label className="form-label">
            Location<sup className="required">*</sup>
          </label>
          <div className="input-group">
            <input
              type="text"
              value={locationValue}
              {...register(`maplatlong`, { required: true })}
              name="maplatlong"
              placeholder="Latitude/Longitude"
              className="form-control"
              autoComplete="new-password"
              spellCheck={false}
              onChange={editNewData}
              readOnly
            />
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => setModalVisible(true)}
            >
              <i className="pi pi-map"></i>
            </button>
          </div>
          {errors.maplatlong && (
            <span className="error">Location is required</span>
          )}
          <LocationMapPopup
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            mapPopupInput={mapPopupInput}
            setMapPopupInput={setMapPopupInput}
            handleInput={handleInput}
            mapData={mapData}
            setMapData={setMapData}
            handleMapLatLon={handleMapLatLon}
          />
          <div className="status-switch">
            <label className="form-label">Status</label>
            <InputSwitch
              {...register("status")}
              name="status"
              checked={checked}
              value={idData?.status}
              onChange={(e: any) => (editNewData(e), setChecked(e.value))}
            />
          </div>
        </div>
        <div className="col-md-6">
          <label className="form-label">Notes</label>
          <textarea
            value={idData && idData?.notes}
            {...register("notes")}
            name="notes"
            placeholder="Notes"
            className="form-control"
            autoComplete="new-password"
            spellCheck={false}
            onChange={editNewData}
          ></textarea>
        </div>
        <div className="col-md-12 btngroup">
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => navigate(`/aura-camera/sites`)}
          >
            <i className="pi pi-arrow-left"></i> Back
          </button>
          <input
            type="submit"
            value={isAddMode ? "Submit" : "Update"}
            className="btn btn-primary"
          />
        </div>
      </form>
    </>
  );
};

export default AddEditForm;
